import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import MyCoursesPage from './components/MyCoursesPage';
import PlaylistPage from './components/PlaylistPage';
import VideoPage from './components/VideoPage';
import ClerkLoginPage from './components/ClerkLoginPage';
import ClerkSignupPage from './components/ClerkSignupPage';
import LandingPage from './components/LandingPage';
import ProfilePage from './components/ProfilePage';
import { Toaster } from 'react-hot-toast';
import './App.css';

// Simple component to handle root route - always show LandingPage
const RootRoute = () => {
  return <LandingPage />;
};

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<RootRoute />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/login" element={<ClerkLoginPage />} />
            <Route path="/signup" element={<ClerkSignupPage />} />
            <Route 
              path="/create" 
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-courses" 
              element={
                <ProtectedRoute>
                  <MyCoursesPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } 
            />
            {/* Video page (direct access) */}
            <Route 
              path="/video/:videoUuid" 
              element={
                <ProtectedRoute>
                  <VideoPage />
                </ProtectedRoute>
              } 
            />
            {/* Video page with playlist context */}
            <Route 
              path="/:playlistUuid/:videoUuid" 
              element={
                <ProtectedRoute>
                  <VideoPage />
                </ProtectedRoute>
              } 
            />
            {/* Playlist page */}
            <Route 
              path="/:uuid" 
              element={
                <ProtectedRoute>
                  <PlaylistPage />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </main>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;
